import type { AnalyticsProvider } from '../types/analytics-provider';
import { PostHogAnalyticsProvider } from './providers/posthog-analytics-provider';

const posthogAnalyticsProvider = new PostHogAnalyticsProvider();

/**
 * Single shared instances for identify, captureEvent, and
 * bootstrap `isEnabled()` checks. Add new providers here only
 * — do not instantiate these classes elsewhere.
 *
 * Sentry user identity lives in
 * @lib/observability/identity/set-sentry-user.client. Sentry
 * is not analytics; it has its own request-scoped semantics.
 */
export const clientAnalyticsProviders: readonly AnalyticsProvider[] = [
  posthogAnalyticsProvider,
];
